import * as React from 'react';
import * as styles from './styles.css';

import { Header0, InlineText1 } from '@cian/ui-kit/typography';

import { NBSP } from '../../../../constants/symbols';

export interface IAsideProps {
  backToPage: React.ReactNode;
}

export function Aside({ backToPage }: IAsideProps) {
  return (
    <>
      {backToPage}
      <h1 className={styles['title']}>
        <Header0>Заявка риелтору</Header0>
      </h1>
      <div className={styles['description']}>
        <InlineText1>
          Информация из этой анкеты поможет подходящему риелтору найти вашу заявку и{NBSP}обработать её. Комиссия
          за услуги обсуждается с риелтором
        </InlineText1>
      </div>
      <div className={styles['img']} />
    </>
  );
}
